const Footer = ({ contactEmail }) => {
  const currentYear = new Date().getFullYear(); 

  return (
    <footer className="footer">
      <p>
        mrbrownie.com.br &copy; {currentYear} Domínio disponível
      </p>
      <p>
        Interessado neste domínio? e-mail: 
        <a href={`mailto:${contactEmail}`}> {contactEmail}</a>
      </p>
      <p>Desenvolvido por <a href="https://www.quartarev.com.br/">QuartaRev Software</a></p>
    </footer>
  );
};

export default Footer;